// QTree()
/*
*/

import sortBy from 'lodash/sortBy';

function deep_copy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

let _qtree_id = 1;

class QTree {

  constructor(raw) {
    raw = raw || [];
    // this._initial = deep_copy(raw); // LL: Do we need this?
    this._current = deep_copy(raw);
    this.tree = {}; // {id: item}

    if (raw) {
      if (raw instanceof QTree) {
        this.tree = deep_copy(raw.tree);
      } else {
        this.tree = this.parse(raw);
      }
    }

    this._generate_instance_id();
  }

  fromTree(object_tree) {
    //TODO: destroy this, only used in the processes table
    let new_tree = [];

    function node_children(node) {
      if (!node) {
        return [];
      }
      let new_node = {...node};
      new_node.children = [...(node.children || [])]
      let childs = [new_node];

      if (node.children) {
        for (let child of node.children) {
          let a = node_children(child)
          a.children = [...(node.children || [])]
          childs = childs.concat(a)
        }
      }
      
      return childs;
    }

    if (object_tree) {
      for (let node of object_tree) {
        new_tree = new_tree.concat(node_children(node));
      }
    }

    this._current = new_tree;
    this.tree = this.parse(new_tree);
    this._generate_instance_id();
  }

  get(oid) {
    return this.tree[oid];
  }

  parse(raw) {
    // Parse data 
    const tree = {};

    // Build tree
    for (const item of raw) {
      tree[item.id] = item;
      tree[item.id].children = item && item.children ? item.children : [];
    }

    // Populate children by scaning the kids and attaching them to its parent
    for (const [id, item] of Object.entries(tree)) {
      if (item.parent !== null && tree[item.parent] && !tree[item.parent].children.find(node => node.id == item.id)) {
        tree[item.parent].children.push(tree[id]);
      }
    }

    return tree;
  }

  path(oid) {
    /**
        * Returns a list of ids from root to oid
    */
    let res = [oid];
    const tree = Object.fromEntries(this.plain_tree().map( it => ([it.id, it])))
    while (tree[res.at(-1)].parent !== null) {
        res.push(tree[res.at(-1)].parent);
    }
    res.reverse();
    return res;
  }

  _generate_instance_id() {
    // Generate a unique identifier
    this.instance_id = _qtree_id++ ; // Vue reactive winks
  }

  plain_tree() {
    /**
      * Returns array of objects with current order
    */
    // Takes all nodes of the tree into the array
    function plain_tree(roots) {
      let res = [];
      for (const item of roots) {
        let sort_item = item;
        if (item.children && item.children.length > 0) {
          res = res.concat(plain_tree(item.children));
        }
        res.push(sort_item);
      }
      return res;
    }
    return plain_tree(this.get_array_tree());
  }

  get_root_objects() {
    /**
      * Returns array of tree objects with no parent
      */
    return Object.values(this.tree).filter(item => !item.parent || !this.tree[item.parent]);
  }

  get_parented_objects() {
    /**
      * Returns array of tree objects that have a parent
      */
    return Object.values(this.tree).filter(item => item.parent);
  }

  get_array_tree() {
    /**
      * Returns array of tree objects with root objects and its children sorted 
      */
    function recursive_array_tree(roots,iter=0) {
      // roots: [{root1}, {root2}]
      // Returns [{root1, children:[{kid_root1_1},{kid_root1_2}]},  {root2, children:[{kid_root2_1},{kid_root2_2}]}]

      // Max 5 iterations
      if (iter >= 5) { 
        return roots;
      }
      let res = [];
      for (const item of roots) {
        let sort_item = item;
        if (item.children && item.children.length > 0) {
          sort_item.children = recursive_array_tree(item.children,iter+1);
        }
        res.push(sort_item);
      }
      return res;
    }

    const roots = this.get_root_objects();
    return recursive_array_tree(roots);
  }

  sort_plain_tree(attrs) {
    const raw = sortBy(this.plain_tree(), attrs);
    // Rebuild tree
    for (const item of raw) {
      this._current.push(item.id);
    }
    // Require reactive?
    this._generate_instance_id();
  }  

  custom_tree_sort(name) {
    /*
      Sort current tree with the value given
    */
    function recursive_sort(roots, name) {
      let res = [];

      for (const item of sortBy(roots, [name])) {
        let sort_item = item;
        if (item.children && item.children.length > 0) {
          sort_item.children = recursive_sort(item.children, name);
        }
        res.push(sort_item);
      }
      return res;
    }

    const sorted = recursive_sort(this.get_array_tree(),name)
    this._current = sorted
    this.tree = sorted;
    
    this._generate_instance_id();
  }

  map(func) {
    /*
      Modify each node with the function given
    */
    function recursive_map(roots, func) {
      let res = [];
      for (const item of roots.map((it => func(it)))) {
        let sort_item = item;
        if (item.children && item.children.length > 0) {
          sort_item.children = recursive_map(item.children, func);
        }
        res.push(sort_item);
      }
      return res;
    }

    return new QTree(recursive_map(this.get_array_tree(),func));
  }

  filter(name,value) {
    /*
      Modify each node with the name and value given
    */
    function recursive_filter(roots, name, value) {
      let res = [];
      let filtered = roots.filter(it => it[name] == value)
      for (const item of filtered) {
        let sort_item = item;
        
        if (item.children && item.children.length > 0) {
          sort_item.children = recursive_filter(item.children, name, value);
        }
        res.push(sort_item);
      }
      return res;
    }

    return new QTree(recursive_filter(this.get_array_tree(), name, value));
  }

  filter_funct(func) {
    /*
      Filter each node with the function given
    */
    function recursive_filter(roots, func) {
      let res = [];
      let filtered = roots.filter(it => func(it))
      for (const item of filtered) {
        let sort_item = item;
        if (item.children && item.children.length > 0) {
          sort_item.children = recursive_filter(item.children, func);
        }
        res.push(sort_item);
      }
      return res;
    }
    

    return new QTree(recursive_filter(this.get_array_tree(),func));
  }
}

export default QTree
